/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createEnterprisesRepository = (options: RestApiOptions): Types.EnterprisesRepository => ({
    async getPaymentConfiguration(params, requestOptions) {
        return options.request('/enterprises/getPaymentConfiguration', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
